import * as React from 'react';
import { Study } from './fetchData';

const defaultStudy = {
    orgId: '',
    orgName: '',
    status: 'active',
    theme: 'default',
    id: '',
    steps: [],
    language: 'en',
    locationType: 'link',
    slotLength: 30,
    legal: {
        id: '',
        duration: '0',
        fullText: '',
        language: 'en',
        shortText: '',
        type: 'booking',
        version: 1,
    },
    translations: [],
    active: false,
} satisfies Study;

const Context = React.createContext<{
    study: Study;
    updateStudy: (newStudy: Study) => void;
}>({
    study: defaultStudy,
    updateStudy: () => {},
});

function StudyProvider({
    children,
    initStudy,
}: React.PropsWithChildren<{ initStudy: Study }>) {
    const [study, updateStudy] = React.useState<Study>(
        initStudy ?? defaultStudy,
    );

    const value = {
        study,
        updateStudy,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}

function useStudyContext() {
    const context = React.useContext(Context);
    if (context === undefined) {
        throw new Error('useCount must be used within a CountProvider');
    }
    return context;
}

export { StudyProvider, useStudyContext };
